import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, CircularProgress, TextField
} from "@mui/material";
import { useState, useEffect } from "react";

function DashboardTitreModal({ open, onClose, tournee, onSave, loading }) {
    const [libelle, setLibelle] = useState('');

    useEffect(() => {
        if (open) {
            setLibelle(tournee?.libelle || '');
        }
    }, [open, tournee]);

    const trimmed = libelle.trim();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle><strong>{tournee?.libelle}</strong></DialogTitle>

            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    label="Titre de la tournée"
                    value={libelle}
                    onChange={(e) => setLibelle(e.target.value)}
                    sx={{ mt: 1 }}
                    inputProps={{ maxLength: 255 }}
                />
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={() => onSave(tournee?.id, trimmed)}
                    variant="contained"
                    color="secondary"
                    disabled={loading || !trimmed || trimmed === tournee?.libelle}
                >
                    {!loading ? "Valider" : <CircularProgress size={20} />}
                </Button>
                <Button onClick={onClose} variant="contained" color="primary">
                    Annuler
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DashboardTitreModal;
